// Import and register all Stimulus controllers
// Note: The application will be passed in from the main application.js file

// import TypeaheadController from "./typeahead_controller"  // DISABLED - using simple-typeahead instead
import SimpleTypeaheadController from "./simple_typeahead_controller"
import TomSelectController from "./tom_select_controller"
import SortableController from "./sortable_controller"
import TableController from "./table_controller"
import FileUploadController from "./file_upload_controller"
import ContactFieldsController from "./contact_fields_controller"
import TaskFormController from "./task_form_controller"
import FilterFormController from "./filter_form_controller"
import AutoSaveController from "./auto_save_controller"
import TurboFieldController from "./turbo_field_controller"
import CharacterLimitController from "./character_limit_controller"
import FlatpickrController from "./flatpickr_controller"

// Export a function to register all controllers
export function registerControllers(application) {
  // application.register("typeahead", TypeaheadController)  // DISABLED - using simple-typeahead instead
  application.register("simple-typeahead", SimpleTypeaheadController)
  application.register("tom-select", TomSelectController)
  application.register("sortable", SortableController)
  application.register("table", TableController)
  application.register("file-upload", FileUploadController)
  application.register("contact-fields", ContactFieldsController)
  application.register("task-form", TaskFormController)
  application.register("filter-form", FilterFormController)
  application.register("auto-save", AutoSaveController)
  application.register("turbo-field", TurboFieldController)
  application.register("character-limit", CharacterLimitController)
  application.register("flatpickr", FlatpickrController)
}